import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';

export const Route = createFileRoute('/_authenticated/_management/administration/benutzerinnen')({
  component: ContainerLayout,
});
